<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="register id" prop="registerId">
                <Input type="text" v-model="searchForm.registerId" placeholder="请输入vip id" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="登录账户" prop="account">
                <Input type="text" v-model="searchForm.account" placeholder="请输入登录账户" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="实名后的名称" prop="name">
                <Input type="text" v-model="searchForm.name" placeholder="请输入实名后的名称" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="会员类型" prop="type">
                <Select v-model="searchForm.type">
                  <Option value="">全部</Option>
                  <Option value="person">个人</Option>
                  <Option value="enterprise">企业</Option>
                </Select>
                  <!--<Input type="text" v-model="searchForm.type" placeholder="请输入会员类型  person:个人  enterprise:企业。" clearable style="width: 200px"/>-->
              </Form-item>
                <!--<Form-item label="会员结束日期。" prop="enddate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="来源平台。" prop="source">
                  <Input type="text" v-model="searchForm.source" placeholder="请输入来源平台。" clearable style="width: 200px"/>
                </Form-item>-->
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <!--<Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>-->
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        <FormItem label="vip id" prop="registerId" >
          <Input v-model="form.registerId" style="width:100%"/>
        </FormItem>
        <FormItem label="会员类型  person:个人  enterprise:企业。" prop="type" >
          <Input v-model="form.type" style="width:100%"/>
        </FormItem>
        <FormItem label="会员结束日期。" prop="enddate" >
            <DatePicker type="date" v-model="form.enddate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="来源平台。" prop="source" >
          <Input v-model="form.source" style="width:100%"/>
        </FormItem>
        <FormItem label="备注" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="业务类型  对应register_vip_config表中的code字段。" prop="vipCode" >
          <Input v-model="form.vipCode" style="width:100%"/>
        </FormItem>
        <FormItem label="存证次数" prop="evidenceArchiveNum" >
          <Input v-model="form.evidenceArchiveNum" style="width:100%"/>
        </FormItem>
        <FormItem label="证书登记次数" prop="copyrightRegisterNum" >
          <Input v-model="form.copyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记次数" prop="preNum" >
          <Input v-model="form.preNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记转登记1工剩余次数" prop="preNum" >
          <Input v-model="form.oneCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记转登记3工剩余次数" prop="preNum" >
          <Input v-model="form.threeCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记转登记5工剩余次数" prop="preNum" >
          <Input v-model="form.fiveCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="图片监听次数" prop="imageMonitorNum" >
          <Input v-model="form.imageMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="音乐监听次数" prop="musicMonitorNum" >
          <Input v-model="form.musicMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="文本监听次数" prop="textMonitorNum" >
          <Input v-model="form.textMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="取证次数" prop="forensicsNum" >
          <Input v-model="form.forensicsNum" style="width:100%"/>
        </FormItem>
        <FormItem label="律师咨询（电话）次数" prop="lawyerConsultNum" >
          <Input v-model="form.lawyerConsultNum" style="width:100%"/>
        </FormItem>
        <FormItem label="出具律师函次数" prop="judicialEvidenceNum" >
          <Input v-model="form.judicialEvidenceNum" style="width:100%"/>
        </FormItem>
        <FormItem label="登录账户" prop="account" >
          <Input v-model="form.account" style="width:100%"/>
        </FormItem>
        <FormItem label="账户类型:enterprise：企业,person：个人" prop="accountType" >
          <Input v-model="form.accountType" style="width:100%"/>
        </FormItem>
        <FormItem label="用户自定义昵称（也可能是第三方平台 微信 微博 qq昵称）" prop="nickName" >
          <Input v-model="form.nickName" style="width:100%"/>
        </FormItem>
        <FormItem label="实名后的名称" prop="name" >
          <Input v-model="form.name" style="width:100%"/>
        </FormItem>
        <FormItem label="身份证号" prop="idCardNoEncrypt" >
          <Input v-model="form.idCardNoEncrypt" style="width:100%"/>
        </FormItem>
        <FormItem label="密码，md5 加密。" prop="password" >
          <Input v-model="form.password" style="width:100%"/>
        </FormItem>
        <FormItem label="联系邮箱" prop="email" >
          <Input v-model="form.email" style="width:100%"/>
        </FormItem>
        <FormItem label="Email绑定状态 0 未绑定  1 绑定" prop="emailBindStatus" >
          <Input v-model="form.emailBindStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="手机号" prop="mobilePhoneEncrypt" >
          <Input v-model="form.mobilePhoneEncrypt" style="width:100%"/>
        </FormItem>
        <FormItem label="手机号绑定状态" prop="mobileBindStatus" >
          <Input v-model="form.mobileBindStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回" prop="realNameStatus" >
          <Input v-model="form.realNameStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="联系电话，这个通常说的是座机。" prop="phone" >
          <Input v-model="form.phone" style="width:100%"/>
        </FormItem>
        <FormItem label="登记人头像" prop="photo" >
          <Input v-model="form.photo" style="width:100%"/>
        </FormItem>
        <FormItem label="联系地址" prop="address" >
          <Input v-model="form.address" style="width:100%"/>
        </FormItem>
        <FormItem label="邮政编码" prop="zipCode" >
          <Input v-model="form.zipCode" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人传真" prop="fax" >
          <Input v-model="form.fax" style="width:100%"/>
        </FormItem>
        <FormItem label="传真" prop="areaCode" >
          <Input v-model="form.areaCode" style="width:100%"/>
        </FormItem>
        <FormItem label="注册时间" prop="regTime" >
          <DatePicker type="date" v-model="form.regTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="注册来源终端:pc,android,ios,weixin" prop="regTerminal" >
          <Input v-model="form.regTerminal" style="width:100%"/>
        </FormItem>
        <FormItem label="备注" prop="remark" >
          <Input v-model="form.remark" style="width:100%"/>
        </FormItem>
        <FormItem label="来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。" prop="platformSource" >
          <Input v-model="form.platformSource" style="width:100%"/>
        </FormItem>
        <FormItem label="来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin" prop="appName" >
          <Input v-model="form.appName" style="width:100%"/>
        </FormItem>
        <FormItem label="是否可登录 0 不可登录 1 可正常登录" prop="loginFlag" >
          <Input v-model="form.loginFlag" style="width:100%"/>
        </FormItem>
        <FormItem label="原创签名" prop="originalSignature" >
          <Input v-model="form.originalSignature" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <!--<Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>-->
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "RegisterVipMember",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "a.create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        registerId: "",
        type: "",
        enddate: "",
        source: "",
        remarks: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "registerId",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "会员类型",
          key: "type",
          minWidth: 120,
          sortable: false,
            render(h, params){
              return h('span', params.row.type =='person'?'个人':params.row.type =='enterprise'?'企业':'未知')
            }
        },
        {
          title: "会员结束日期。",
          key: "enddate",
          minWidth: 120,
          sortable: false,
        },
        // {
        //   title: "来源平台。",
        //   key: "source",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "备注",
        //   key: "remarks",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "操作",
        //   key: "action",
        //   align: "center",
        //   width: 200,
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small",
        //             icon: "ios-create-outline"
        //           },
        //           style: {
        //             marginRight: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               this.edit(params.row);
        //             }
        //           }
        //         },
        //         "查看"
        //       )/*,
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             icon: "md-trash"
        //           },
        //           on: {
        //             click: () => {
        //               this.remove(params.row);
        //             }
        //           }
        //         },
        //         "删除"
        //       )*/
        //     ]);
        //   }
        // },
        /*{
            title: "业务类型  对应register_vip_config表中的code字段。",
            key: "vipCode",
            minWidth: 120,
            sortable: false,
        },*/
        {
            title: "存证次数",
            key: "evidenceArchiveNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "证书登记次数",
            key: "copyrightRegisterNum",
            minWidth: 120,
            sortable: false,
        },
        {
          title: "预登记次数",
          key: "preNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预登记转登记1工剩余次数",
          key: "oneCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预登记转登记3工剩余次数",
          key: "threeCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预登记转登记5工剩余次数",
          key: "fiveCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
        },
        {
            title: "图片监听次数",
            key: "imageMonitorNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "音乐监听次数",
            key: "musicMonitorNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "文本监听次数",
            key: "textMonitorNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "取证次数",
            key: "forensicsNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "律师咨询（电话）次数",
            key: "lawyerConsultNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "出具律师函次数",
            key: "judicialEvidenceNum",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "登录账户",
            key: "account",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "实名后的名称",
            key: "name",
            minWidth: 120,
            sortable: false,
        },
        /*{
            title: "实名状态  un_real_name：未实名     wait_certificate：待上传实名证件    wait_approve：待实名审核     complete_real_name：已实名   reject_real_name：实名驳回",
            key: "realNameStatus",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "联系电话，这个通常说的是座机。",
            key: "phone",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "登记人头像",
            key: "photo",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "联系地址",
            key: "address",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "邮政编码",
            key: "zipCode",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "联系人传真",
            key: "fax",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "传真",
            key: "areaCode",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "注册时间",
            key: "regTime",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "注册来源终端:pc,android,ios,weixin",
            key: "regTerminal",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "备注",
            key: "remark",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "来源平台，大部分是开放平台的app_id,有其他的一些未知渠道，什么360，baidu,migu_misic 遗留数据尚不清楚。",
            key: "platformSource",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "来源系统:banquanjia：“版权家”，bqjClientEditionMac : 版权家  bqjClientEditionWin",
            key: "appName",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "是否可登录 0 不可登录 1 可正常登录",
            key: "loginFlag",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "原创签名",
            key: "originalSignature",
            minWidth: 120,
            sortable: false,
        },
        {
            title: "备注信息",
            key: "remarks",
            minWidth: 120,
            sortable: false,
        }*/
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/registerVipMember/findPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // 以下为模拟数据
      //this.data = [
      //];
      // this.total = this.data.length;
      // this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>